export const ROLES = {
  admin: 'admin',
  orgadmin: 'org_admin',
  controller: 'controller',
  reader: 'reader',
  reporter: 'reporter',
};

export const SCOPES = {
  canChangeMissionApproval: 'can-change-mission-approval',
  canChangeOperationStatus: 'can-change-operation-status',
  canAddZone: 'can-add-zone',
  canChangeZone: 'can-change-zone',
  canDeleteZone: 'can-delete-zone',
  canAddCorridor: 'can-add-corridor',
  canChangeCorridor: 'can-change-corridor',
  canDeleteCorridor: 'can-delete-corridor',
  empty: 'empty',
};

export const PERMISSIONS = {
  [ROLES.admin]: [
    SCOPES.canChangeMissionApproval,
    SCOPES.canChangeOperationStatus,
    SCOPES.canAddZone,
    SCOPES.canChangeZone,
    SCOPES.canAddCorridor,
    SCOPES.canChangeCorridor,
    SCOPES.canDeleteCorridor,
    SCOPES.canDeleteZone,
  ],
  [ROLES.orgadmin]: [
    SCOPES.canChangeMissionApproval,
    SCOPES.canChangeOperationStatus,
    SCOPES.canAddZone,
    SCOPES.canChangeZone,
    SCOPES.canAddCorridor,
    SCOPES.canChangeCorridor,
    SCOPES.canDeleteCorridor,
    SCOPES.canDeleteZone,
  ],
  [ROLES.controller]: [
    SCOPES.canChangeMissionApproval,
    SCOPES.canChangeOperationStatus,
    SCOPES.canAddZone,
    SCOPES.canChangeZone,
    SCOPES.canAddCorridor,
    SCOPES.canChangeCorridor,
    SCOPES.canDeleteCorridor,
    SCOPES.canDeleteZone,
  ],
  [ROLES.reader]: [SCOPES.empty],
  [ROLES.reporter]: [SCOPES.empty],
};
